import axios from 'axios';

class TradingHoursService {
  constructor() {
    this.baseURL = '/api/trading-hours';
  }

  async getTradingHours() {
    try {
      const response = await axios.get(this.baseURL, {
        withCredentials: true,
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching trading hours:', error);
      throw error;
    }
  }

  async saveTradingHours(tradingHoursData) {
    try {
      const response = await axios.post(this.baseURL, tradingHoursData, {
        withCredentials: true,
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error saving trading hours:', error);
      throw error;
    }
  }

  getAuthHeaders() {
    const headers = {};
    const token = localStorage.getItem('token') || localStorage.getItem('access_token');
    const userData = localStorage.getItem('user');

    if (userData) {
      headers['X-User-Data'] = userData;
    }

    if (token && token !== 'wordpress-sso') {
      headers['Authorization'] = `Bearer ${token}`;
    }

    if (token === 'wordpress-sso') {
      headers['X-WP-SSO'] = 'true';
    }

    return headers;
  }
}

export const tradingHoursService = new TradingHoursService();